import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../AuthContext";

const ADMIN_ROLES = ["support", "moderator", "admin", "super_admin"];

export const AdminGuard = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="cc cc-bg min-h-screen flex items-center justify-center text-white/60">Loading…</div>;
  if (!user) return <UnauthorizedView reason="You must be logged in to access the admin panel." login />;
  if (!ADMIN_ROLES.includes(user.role)) return <UnauthorizedView reason="Your account does not have administrative privileges." />;
  return children;
};

const UnauthorizedView = ({ reason, login }) => (
  <div className="cc cc-bg min-h-screen flex items-center justify-center px-4" data-testid="admin-unauthorized">
    <div className="cc-card rounded-2xl p-10 max-w-md text-center">
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/15 text-red-300">
        <ShieldAlert size={26} />
      </div>
      <h1 className="cc-heading text-xl font-600 text-white">Unauthorized Access</h1>
      <p className="text-slate-400 text-sm mt-2">{reason}</p>
      <div className="mt-6 flex justify-center gap-3">
        {login && <Link to="/credit/login" className="cc-btn-primary rounded-xl px-5 py-2.5 text-sm font-500">Log in</Link>}
        <Link to="/credit/app" className="rounded-xl border border-white/12 px-5 py-2.5 text-sm text-white cc-nav-item">Back to app</Link>
      </div>
    </div>
  </div>
);
